module.exports = __webpack_public_path__ + "img/illustration-features.696a03c6.png";